import { useState } from "react";
import styles from "./Navbar.module.css";

const Navbar = () => {
  const [toggle, setToggle] = useState(false);

  return (
    <header className={styles.header}>
      <nav className={`${styles.navbar} container`}>
        <a href="#home">
          <span>Gui</span>folio.
        </a>
        <div
          className={
            toggle ? `${styles.show_menu} ${styles.nav_menu}` : styles.nav_menu
          }
        >
          <ul className="grid">
            <li>
              <a href="#home">
                <i className={`${styles.icons} uil uil-estate`}></i>
                Home
              </a>
            </li>
            <li>
              <a href="#about">
                <i className={`${styles.icons} uil uil-user`}></i>Sobre
              </a>
            </li>
            <li>
              <a href="#skills">
                <i className={`${styles.icons} uil uil-brackets-curly`}></i>
                Skills
              </a>
            </li>
            <li>
              <a href="#portfolio">
                <i className={`${styles.icons} uil uil-bag`}></i>Portfolio
              </a>
            </li>
            <li>
              <a href="#contact">
                <i className={`${styles.icons} uil uil-message`}></i>Contato
              </a>
            </li>
          </ul>
          <i
            className={`${styles.nav_close} fa-solid fa-xmark`}
            onClick={() => {
              setToggle(!toggle);
            }}
          ></i>
        </div>
        <div
          className={styles.nav_toggle}
          onClick={() => {
            setToggle(!toggle);
          }}
        >
          <i className="fa-solid fa-bars"></i>
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
